(function () {
  siteMenu();
  accordion();
  setVideoWidth();
  variantPicker();
  makeSticky();
  relatedThumbnails();
  setTimelineMargin();

  document.addEventListener('UPEZ_CART_CLOSED', () => {
    console.log('closed cart');
    const _atc = document.querySelector('.product-form__submit');

    if (_atc) {
      const _spinner = document.querySelector('.product-form__submit .loading__spinner');
      _spinner.classList.add('hidden');

      _atc.classList.remove('loading');
      _atc.removeAttribute('aria-disabled');

      jQuery('.js-related-atc').removeClass('loading');
      jQuery('.js-custom-atc').removeClass('loading');
      jQuery('.product-list__item .button').removeClass('loading');
    }

    jQuery('.pairing').removeClass('open');

  });

  jQuery('.js-related-atc, .js-custom-atc, .product-list__item .button').click(function () {
    jQuery(this).addClass('loading');
  });

  window.addEventListener('resize', () => {
    makeSticky();
  });

  jQuery(window).resize(function () {
    // setTimeout( setTimelineMargin, 200);
    setTimelineMargin();
  });


  jQuery('.js-goto-testi').click(function () {
    jQuery('html, body').animate({
      scrollTop: jQuery('#testimonials').offset().top - 100
    });
  });

  jQuery('.product-header .product-rating').click(function () {
    jQuery('html, body').animate({
      scrollTop: jQuery('#testimonials').offset().top - 250
    });
  });

  jQuery(".js-switch").click(function (e) {
    e.preventDefault();
    const _parent = jQuery(this).parent().parent();
    const _select = jQuery('select', _parent);

    const _val = jQuery(this).data('val');
    _select.val(_val);

    jQuery(".js-switch").removeClass('active');
    jQuery(this).addClass('active');

    const _parentCard = jQuery(this).closest('.product-list__item');
    const _mainImage = jQuery('.js-main', _parentCard);
    const _getIndex = jQuery(this).data('index');
    const _getUrl = jQuery('.js-image-' + _getIndex, _parentCard).data('url');
    _mainImage.attr('src', _getUrl);
    console.log(_parentCard);

    const _title = `<b>${jQuery(this).data('name')}</b>`;
    const _isBundle = jQuery(this).hasClass('variant-bundle');

    if (_isBundle) {
      jQuery('.js-bundle-label').html('or Pick a Bundle & Save: ' + _title);
      jQuery('.js-individual-label').html('Pick Individual Shades:');

    } else {
      jQuery('.js-individual-label').html('Pick Individual Shades: ' + _title);
      jQuery('.js-bundle-label').html('or Pick a Bundle & Save:');

    }

  });

  window.addEventListener('resize', () => {
    setVideoWidth();
  });

  window.addEventListener('scroll', () => {
    setVideoWidth();
  });

  window.addEventListener('load', () => {
    const _parent = jQuery('.skio-group-container--selected');
    const _label = jQuery('.skio-group-label', _parent);
    const _textTest = _label.text();

    if (_textTest.indexOf("Subscribe") >= 0) {
      jQuery('.skio-details').addClass('active');
    }

    const _currentPrice = jQuery('.skio-group-container--selected .skio-price').text();
    console.log('Price', _currentPrice);
    if (_currentPrice !== "") {
      const _displayPrice = parseInt(_currentPrice.split('.')[1]) <= 0 ? _currentPrice.split('.')[0] : _currentPrice;
      console.log('Update price');
      jQuery('.js-price-switch').text(_displayPrice);
    }

  });

  jQuery('.skio-group-container').click(function () {
    const _parent = jQuery(this);
    const _label = jQuery('.skio-group-label', _parent);
    const _textTest = _label.text();

    if (_textTest.indexOf("Subscribe") >= 0) {
      jQuery('.skio-details').addClass('active');
    } else {
      jQuery('.skio-details').removeClass('active');
    }

    const _currentPrice = jQuery('.skio-price', jQuery(this)).text();
    if (_currentPrice !== null) {
      const _displayPrice = parseInt(_currentPrice.split('.')[1]) <= 0 ? _currentPrice.split('.')[0] : _currentPrice;
      jQuery('.js-price-switch').text(_displayPrice);
    }
  });

  jQuery('.js-pairing-gallery').owlCarousel({
    items: 1,
    loop: true,
    autoplay: true,
    autoplayTimeout: 5000,
    nav: false,
    dots: false,
    stagePadding: 50,
    margin: 10
  });

  jQuery('.js-testimonial-carousel').owlCarousel({
    items: 1,
    loop: true,
    autoplay: true,
    autoplayTimeout: 5000,
    nav: true,
    dots: false
  });

  jQuery('.js-logo-carousel').owlCarousel({
    items: 3,
    loop: true,
    nav: false,
    dots: false,
    autoplay: true,
    autoplayTimeout: 5000,
    center: false,
    startPosition: 2,
    responsive: {
      // breakpoint from 768 up
      768: {
        items: 6
      }
    },
  });

  jQuery('.js-announcement').owlCarousel({
    animateOut: 'fadeOut',
    items: 1,
    autoplay: true,
    autoplayTimeout: 5000,
    autoHeight: true,
    nav: false,
    dots: false,
    loop: true
  });

  jQuery('.js-open-pairing').click(function (e) {
    e.preventDefault();
    jQuery('.pairing').addClass('open');
    jQuery('.mobile-navigation').removeClass('active');
  });

  jQuery('.js-choose-shade').click(function (e) {
    e.preventDefault();
    jQuery('.section--product-list').addClass('open');
    jQuery('.pairing').removeClass('open');
    jQuery(this).next().addClass('open');
    jQuery('.mobile-navigation').removeClass('active');
  });

  jQuery('.js-close-pairing').click(function (e) {
    e.preventDefault();
    jQuery('.section--product-list').removeClass('open');
    jQuery('.pairing').removeClass('open');
  });

  jQuery('.pairing-info .variant-switcher a').click(function () {
    jQuery('.pairing-info .variant-switcher a').removeClass('active');
    jQuery(this).addClass('active');
  });

  jQuery('.main-product .collapsible-question').click(function () {
    jQuery(this).next().slideToggle();
    jQuery(this).toggleClass('active');
    makeSticky();
  });

  jQuery('.js-see-more').click(function () {
    jQuery(this).parent().toggleClass('active');
  });

  jQuery('.js-faq-header').click(function () {
    const _id = jQuery(this).data('group');
    jQuery(this).toggleClass('is-closed');
    jQuery('.faq-item.' + _id).toggleClass('is-hidden');
  });

  jQuery('.faq-item__question').click(function () {
    jQuery(this).toggleClass('is-open');
    jQuery(this).next().toggle();
  });

  jQuery('.faq-buttons a').click(function (e) {
    e.preventDefault();

    const _id = jQuery(this).data('id');
    const _targetElement = jQuery('.faq-header-' + _id);
    const _top = _id == 'all' ? 0 : _targetElement.offset().top;

    jQuery('.faq-buttons a').removeClass('active');
    jQuery(this).addClass('active');

    const _offset = window.innerWidth < 767 ? 280 : 150;

    jQuery('html, body').animate({
      scrollTop: _top - _offset
    }, 1000);

  });

  jQuery('.js-faq-topic').on('keyup', function () {
    const _value = jQuery(this).val().toLowerCase();

    jQuery('.faq-item').filter(function () {
      jQuery(this).toggle(jQuery(this).text().toLowerCase().indexOf(_value) > -1);
    });
  });

  const _mainGallery = jQuery('.js-gallery-main').owlCarousel({
    items: 1,
    dots: true,
    nav: false,
    responsive: {
      // breakpoint from 0 up
      0: {
        dots: false,
        stagePadding: 50,
        margin: 15
      },
      // breakpoint from 768 up
      768: {
        dots: true,
        stagePadding: 0,
        margin: 5
      }
    },
    onChanged: function (element) {
      const _index = element.item.index;
      jQuery('.js-gallery-thumb .gallery-item').removeClass('active');
      jQuery('.js-gallery-thumb .gallery-item.thumb-' + (_index + 1)).addClass('active');

      const _position = jQuery('.js-gallery-thumb .gallery-item.thumb-' + (_index + 1)).height() * (_index + 1);
      slideToThumb(_position);
    }
  });

  jQuery('.js-gallery-thumb .gallery-item').click(function () {
    const _inx = jQuery(this).data('index');

    _mainGallery.trigger('to.owl.carousel', _inx - 1);
    jQuery('.js-gallery-thumb .gallery-item').removeClass('active');
    jQuery(this).addClass('active');
  });

  // jQuery('.js.product-form__input--pill label').click(function(){
  //   const _inx = jQuery(this).data('index');
  //   const _gallerySize = jQuery('.gallery-big').data('size-nonvariant');

  //   console.log( _inx, _gallerySize );

  //   _mainGallery.trigger('to.owl.carousel', _inx + _gallerySize );
  // });

  const _btnATC = jQuery('.product-form__buttons .product-form__submit');

  jQuery(window).on('scroll', function () {
    if (scrollY > 129) {
      jQuery('.section--faq-group .faq-buttons').addClass('is-sticky');
    } else {
      jQuery('.section--faq-group .faq-buttons').removeClass('is-sticky');
    }

    if (_btnATC.length > 0) {
      if (scrollY > _btnATC.offset().top + 200) {
        jQuery('.stick-atc').addClass('active');
      } else {
        jQuery('.stick-atc').removeClass('active');
      }
    }
  });


  jQuery('.section--hero .js-okeReviews a').click(function () {
    const _anchor = jQuery(this).attr('href');

    jQuery('html, body').animate({
      scrollTop: jQuery(_anchor).offset().top
    });
  });

  if (jQuery('.section--main-product').length) {

    jQuery('.product-gallery .main-gallery').addClass('lyvecomChecker')

    setInterval(function () {
      if ($('.lyvecom_carousel-component').height() > 0) {
        jQuery('.product-gallery .main-gallery').removeClass('lyvecomChecker')
      }
    }, 500);
  }

  // Landing Page Scripts

  if (jQuery('.lp-text-slider-container').length) {
    jQuery('.lp-text-slider-container').owlCarousel({
      autoplayHoverPause: false,
      autoWidth: true,
      // autoHeight: true,
      touchDrag: false,
      mouseDrag: false,
      loop: true,
      infinite: true,
      autoplay: 1000,
      slideTransition: 'linear',
      autoplayTimeout: 6000,
      autoplaySpeed: 6000,
      nav: false,
      dots: false,
      responsive: {
        0: {
          items: 8,
          margin: 50
        },
        768: {
          items: 8,
          margin: 50
        },
        1024: {
          items: 8,
          stagePadding: 0,
          margin: 80
        }
      }
    });

    jQuery('.lp-text-slider-container .owl-carousel').trigger('play.owl.autoplay', [6000]);

    function setSpeed() {
      jQuery('.lp-text-slider-container .owl-carousel').trigger('play.owl.autoplay', [6000]);
    }

    setTimeout(setSpeed, 1000);

  }

  if (jQuery('.lp-testimonial-slider__container')) {
    var testimonial = jQuery('.lp-testimonial-slider__container').owlCarousel({
      autoWidth: false,
      autoHeight: true,
      loop: false,
      infinite: false,
      center: false,
      // startPosition: 1,
      // rtl: true,
      // navText: ['<button class="slider-next">Next</button>', ' <button class="slider-prev">Previous</button>'],
      responsive: {
        0: {
          items: 1,
          dots: true,
          nav: false,
          center: true
        },
        768: {
          items: 1,
          dots: true,
          nav: false,
          center: true
        },
        1024: {
          items: 5,
          slideBy: 1,
          nav: true,
          dots: false
        }
      }
    });

    $('.slider-prev').click(function () {
      testimonial.trigger('prev.owl.carousel');
    })
    // Go to the previous item
    $('.slider-next').click(function () {
      testimonial.trigger('next.owl.carousel');
    })
  }

  if (jQuery('.lp-comparison-slider')) {
    jQuery('.lp-comparison-slider').owlCarousel({
      autoWidth: true,
      autoHeight: true,
      dots: false,
      nav: true,
      center: true,
      loop: false,
      infinite: false,
      responsive: {
        0: {
          items: 1
        },
        768: {
          items: 1
        }
      }
    });
  }

  if (jQuery(window).width() <= 768) {
    if (jQuery('.product-list.mobile-slider')) {
      jQuery('.product-list.mobile-slider').owlCarousel({
        autoWidth: true,
        autoHeight: true,
        dots: false,
        nav: true,
        center: true,
        loop: true,
        infinite: true,
        margin: 20,
        center: true,
        responsive: {
          0: {
            items: 1
          },
          768: {
            items: 1
          }
        }
      });
    }
  }

  if (jQuery('.shopify-section--lp-accordion .accordion--item')) {
    jQuery('.shopify-section--lp-accordion .accordion--item').on('click', function () {
      var dataId = jQuery(this).attr('data-id');

      jQuery('.accordion--item:not([data-id="' + dataId + '"]):has(.active) .accordion--title').removeClass('active')
    })
  }

  if (jQuery('body.page-landing-page').length) {
    $('a[href*="#"]:not([href="#"])').click(function () {
      var offset = -150; // <-- change the value here
      if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
        if (target.length) {
          $('html, body').animate({
            scrollTop: target.offset().top + offset
          }, 1000);
          return false;
        }
      }
    });

  }

})();

function makeSticky() {

  const _prodInfo = document.querySelector('.main-product');

  if (_prodInfo) {

    const _main = document.querySelector('.main-product .product-gallery');
    const _gallery = document.querySelector('.main-product .main-gallery');
    const _galleryWidth = _main.getBoundingClientRect().width;
    const _headerBrand = document.querySelector('.header-main');
    const _anchor = document.querySelector('.section--checklist');

    console.log('2', _galleryWidth);

    window.addEventListener('scroll', () => {
      stickyProductGallery(_gallery, _galleryWidth, _prodInfo, _headerBrand);
    });

    const elem = document.querySelector('.main-product .product-info');
    let resizeObserver = new ResizeObserver(() => {
      console.log("The element was resized");

      stickyProductGallery(_gallery, _galleryWidth, _prodInfo, _headerBrand);
    });

    resizeObserver.observe(elem);

  }
}

function stickyProductGallery(_gallery, _galleryWidth, _prodInfo, _headerBrand) {
  document.documentElement.style.setProperty('--stickyWidth', _galleryWidth + 'px');
  document.documentElement.style.setProperty('--stickyLeft', _prodInfo.getBoundingClientRect().left + 'px');
  document.documentElement.style.setProperty('--stickyTop', (_headerBrand.clientHeight + 40) + 'px');

  // setTimeout(() => {
  // console.log( _anchor.getBoundingClientRect().top )

  if (scrollY > _prodInfo.getBoundingClientRect().top - 140) {
    _gallery.classList.add('is-sticky');
    _prodInfo.classList.add('is-sticky');
  } else {
    _gallery.classList.remove('is-sticky');
    _prodInfo.classList.remove('is-sticky');
  }

  // console.log( _prodInfo.getBoundingClientRect().bottom, '-', _gallery.clientHeight + _headerBrand.clientHeight );

  if (_prodInfo.getBoundingClientRect().bottom < (_gallery.clientHeight + _headerBrand.clientHeight)) {
    _gallery.classList.add('is-absolute');
  } else {
    _gallery.classList.remove('is-absolute');
  }
  // }, 200);
}

function relatedThumbnails() {
  const _thumbs = jQuery('.related-thumbs');

  if (_thumbs) {
    const _relatedGroup = jQuery('.js-related-group').owlCarousel({
      items: 1,
      nav: false,
      dots: false,
      margin: 15
    });

    _thumbs.click(function () {
      const _index = jQuery(this).data('index');
      _thumbs.removeClass('active');
      jQuery(this).addClass('active');
      _relatedGroup.trigger('to.owl.carousel', _index - 1);

    });


  }

}

function variantPicker() {
  jQuery('label[data-variant]').click(function () {
    const _name = jQuery(this).data('name');
    console.log(_name);

    const _parentLegend = jQuery(this).siblings('legend');
    const _temp = _parentLegend.text();

    _parentLegend.text(_temp + ': ' + _name);

  });
}

function slideToThumb(_pos) {
  const _thumbs = jQuery('.main-product .js-gallery-thumb');
  _thumbs.animate({
    scrollTop: _pos - 100
  });
}

function siteMenu() {
  const _menuBurger = document.querySelector('.header-menu a');
  const _menuClose = document.querySelector('.menu-close');
  const _mobileNav = document.querySelector('.mobile-navigation');

  _menuBurger.addEventListener('click', e => {
    e.preventDefault();
    _mobileNav.classList.toggle('active');
  });

  _menuClose.addEventListener('click', e => {
    e.preventDefault();
    _mobileNav.classList.remove('active');
  });
}

function accordion() {
  const _aTitle = document.querySelectorAll('.accordion--title');
  const _aContent = document.querySelectorAll('.accordion--content');

  _aTitle.forEach(_item => {

    _item.addEventListener('click', e => {
      e.preventDefault();

      // _aTitle.forEach( _content => {
      //   _content.classList.remove('active');
      // });

      _item.classList.toggle('active');
    });
  });
}

function setVideoWidth() {
  const _prodInformation = document.querySelector('.product-info');
  // console.log( _prodInformation );
  if (_prodInformation) {
    const _prodInfoWidth = _prodInformation.clientWidth;
    const _videoWidth = _prodInfoWidth + (window.innerWidth - _prodInformation.getBoundingClientRect().right);
    const _prodVideos = document.querySelector('.prod-videos');

    document.documentElement.style.setProperty('--vidwidth', _videoWidth + 'px');
  }
}

function setTimelineMargin() {
  const _timeline = jQuery('.timeline-list');


  if (_timeline.length > 0) {
    console.log(_timeline);
    const _parentSection = _timeline.closest('.shopify-section');
    const _previousSection = _parentSection.prev();
    const _previousWrapper = jQuery('.wrapper', _previousSection);
    const _leftMargin = _previousWrapper.offset().left;

    _timeline.css({
      'margin-left': _leftMargin + 'px'
    });
  }
}